import Mobiles_Screen_QA450 from './icon-images/Mobiles_Screen_QA450.png';
import Mobiles_Screen_QA340 from './icon-images/Mobiles_Screen_QA340.png';
import Mobiles_Screen_QE140 from './icon-images/Mobiles_Screen_QE140.png';
import Mobiles_Screen_QE241_342_442_2 from './icon-images/Mobiles_Screen_QE241_342_442_2.png';
import Mobiles_Screen_QE241_342_442_3 from './icon-images/Mobiles_Screen_QE241_342_442_3.png';
import Mobiles_Screen_UF320_Direct from './icon-images/Mobiles_Screen_UF320_Direct.png';
import Mobiles_Screen_UF320_Classic from './icon-images/Mobiles_Screen_UF320_Classic.png';
import Mobiles_Screen_UF373 from './icon-images/Mobiles_Screen_UF373.png';

export const getImageMobileScreen = (configuration: number, model: string) => {
  const isQA = model.includes('QA');
  const isQE = model.includes('QE');

  if (isQA) {
    if (model.includes('QA451') || model.includes('QA452'))
      return Mobiles_Screen_QA450;
    return Mobiles_Screen_QA340;
  } else if (isQE) {
    if (model === 'QE141') return Mobiles_Screen_QE140;
    switch (configuration) {
      case 0:
        return Mobiles_Screen_QE241_342_442_3;
      case 1:
        return Mobiles_Screen_QE241_342_442_2;
      default:
        return Mobiles_Screen_QE241_342_442_3;
    }
  } else {
    const isWheeledDirect = model === 'UF320_Direct';
    const isUF373UF473 = model === 'UF373' || model === 'UF473';

    if (isWheeledDirect) {
      return Mobiles_Screen_UF320_Direct;
    } else if (isUF373UF473) {
      return Mobiles_Screen_UF373;
    } else {
      return Mobiles_Screen_UF320_Classic;
    }
  }
};
